const $ = document.querySelector.bind( document );
const header = $( 'header.stick' );
const siteBlocks = $( '.wp-site-blocks' );
const menu = header?.querySelector( '.nav-swv-menu' );
const menuNext = menu?.nextElementSibling;

const hashModals = [ ...document.querySelectorAll( '.wp-block-group[id^="modal-"]' ) ].map( ( modal ) => {
	const wrapper = document.createElement( 'div' );
	wrapper.className = 'swv-modal';
	wrapper.style.display = 'none';
	wrapper.setAttribute( 'aria-hidden', 'true' );
	modal.classList.add( 'swv-modal__dialog' );
	modal.setAttribute( 'role', 'dialog' );
	modal.setAttribute( 'aria-modal', 'true' );
	modal.before( wrapper );
	wrapper.append( modal );
	document.body.append( wrapper );
	return { modal, wrapper };
} );

/**
 * Sync hash modal state after direct navigation and fragment changes.
 *
 * @return void
 */
const syncHashModal = () => {
	const modalId = window.location.hash.slice( 1 );
	const active = hashModals.find( ( { modal } ) => modal.id === modalId );

	hashModals.forEach( ( { modal, wrapper } ) => {
		const isOpen = active?.modal === modal;
		wrapper.style.display = isOpen ? '' : 'none';
		wrapper.setAttribute( 'aria-hidden', String( ! isOpen ) );
	} );

	document.documentElement.classList.toggle( 'has-hash-modal-open', Boolean( active ) );
};

syncHashModal();
window.addEventListener( 'hashchange', syncHashModal );
window.addEventListener( 'pageshow', syncHashModal );

const closeHashModal = () => {
	const url = new URL( window.location.href );
	url.hash = '';
	window.history.replaceState( window.history.state, '', url );
	syncHashModal();
};

document.addEventListener( 'click', ( event ) => {
	const backdrop = event.target.closest( '.swv-modal' );
	if ( backdrop && event.target === backdrop ) {
		closeHashModal();
	}
} );
document.addEventListener( 'keydown', ( event ) => {
	if ( event.key !== 'Escape' || ! document.documentElement.classList.contains( 'has-hash-modal-open' ) ) {
		return;
	}

	closeHashModal();
} );

/**
 * Open modal.
 *
 * @return void
 */
const openModal = ( event ) => {
	$( 'html' ).classList.add( 'has-open-modal' );

	stickHeader( event );
}

/**
 * Close modal.
 *
 * @return void
 */
const closeModal = () => {
	$( 'html' ).classList.remove( 'has-open-modal' );
}

/**
 * Stick header
 *
 * @return void
 */
const stickHeader = ( event ) => {
	if ( ! event.target.closest( '.is-sticky' ) ) {
		header.addEventListener( 'mouseleave', unstickHeader );
	}

	header.classList.add( 'is-sticky' );
}

/**
 * Unstick header
 *
 * @return void
 */
const unstickHeader = () => {
	header.classList.remove('is-sticky');

	header.removeEventListener( 'mouseleave', unstickHeader );
}

/**
 * Add sticky menu event listener.
 *
 * @param MouseEvent event Mouse event.
 * @return void
 */
const addStickyMenuEventListener = ( event ) => {
	siteBlocks.removeEventListener( 'mousemove', addStickyMenuEventListener );

	menuNext.addEventListener( 'mouseenter', stickHeader );

	// Stick immediately when cursor is already on menu.
	if ( event.target.closest( '.nav-swv-menu, .nav-swv-menu + *' ) ) {
		menuNext.addEventListener( 'mousemove', stickHeader );
	}
}

/**
 * Event listeners.
 */
if ( menu?.querySelector( '.nav-swv-submenu' ) ) {
	menu.addEventListener( 'mouseenter', openModal );
	menu.addEventListener( 'mouseleave', closeModal );
}

if ( menuNext && siteBlocks ) {
	siteBlocks.addEventListener( 'mousemove', addStickyMenuEventListener );
}
